<template>
  <v-card-title class="caption color_thead white--text">
    <div>
      {{ ligne.carte.prenom }} {{ ligne.carte.nom }}<br />
      Carte : {{ ligne.carte.num }} {{ ligne.carte.date }}<br />
      Structure : {{ breadCrumbs.structure }}
    </div>
    <v-spacer />
    Fournisseur : {{ ligne.fournisseur }}<br />
    Numéro de la ligne : {{ ligne.num }}
    <v-spacer />
    <div class="text-right">
      Devise origine: {{ ligne.valeur_devise_origine }}
      <v-btn icon color="color_action" class="ml-5" @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <table>
        <thead>
          <th>Tva</th>
          <th
            v-for="(item, i) in ligne.montant.split(',')"
            :key="'head-' + i"
            class="text-center"
          >
            &nbsp;{{ item.split(":")[0] }}&nbsp;
          </th>
        </thead>
        <tbody>
          <th>Montant</th>
          <th
            v-for="(item, i) in ligne.montant.split(',')"
            :key="'head-' + i"
            class="text-center"
          >
            &nbsp; {{ item.split(":")[1] }}&nbsp;&euro;
          </th>
        </tbody>
      </table>
    </div>
  </v-card-title>
</template>

<script>
import { generalMixin } from "@/mixins/general";

export default {
  name: "VueHeadDialogLink",
  mixins: [generalMixin],
  props: {
    ligne: {
      type: Object,
      default: null,
    },
    close: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style scoped></style>
